var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Private Content"}},[_c('p',[_vm._v("Only admins can see this content.")])])}
var staticRenderFns = []

export { render, staticRenderFns }